import React, { useState } from "react";
import UpFile from "./UpFile";
import { useSelector } from "react-redux";
import PreviewPDF from "../../../components/modal/PreviewPdf";

function FileUploader() {
    const {load}=useSelector(state=>state.Load)
    const [modal, setModal] = useState({
        show: false,
        type: "",
        title: "Upload your evidence",
    });

    const [evidences,setEvidences] = useState(load.evidences);
    


    const [modalPrev, setModalPrev] = useState({})
    const deleteItem = () => {
        console.log('Eliminar Documentos')
    }

    return (
        <>
            <div className="space-y-4">
                {/* Selector de tipo */}
                <div className="flex justify-center gap-6">
                    <button
                        type="button"
                        className="flex flex-col items-center text-center"
                        onClick={() => setModal({ ...modal, show: true, type: "pdf" })}
                    >
                        <div
                            className={`
                p-2 rounded-full border
                ${modal.type === "pdf" && modal.show
                                    ? "bg-cs-primary text-white border-cs-primary"
                                    : "bg-cs-bg-alt text-cs-dark border-cs-border"
                                }
                hover:bg-cs-primary-hover hover:text-white transition-colors
              `}
                        >
                            <i className="fas fa-file-alt text-sm" />
                        </div>
                        <span className="text-[11px] mt-1 text-cs-muted">Documents</span>
                    </button>

                    <button
                        type="button"
                        className="flex flex-col items-center text-center"
                        onClick={() => setModal({ ...modal, show: true, type: "img" })}
                    >
                        <div
                            className={`
                p-2 rounded-full border
                ${modal.type === "img" && modal.show
                                    ? "bg-cs-primary text-white border-cs-primary"
                                    : "bg-cs-bg-alt text-cs-dark border-cs-border"
                                }
                hover:bg-cs-primary-hover hover:text-white transition-colors
              `}
                        >
                            <i className="fas fa-image text-sm" />
                        </div>
                        <span className="text-[11px] mt-1 text-cs-muted">Images</span>
                    </button>
                </div>

                {/* Tabla de evidencias */}
                <div className="bg-cs-bg border border-cs-border rounded-xl overflow-hidden">
                    <table className="w-full text-left text-sm">
                        <thead className="bg-cs-bg-alt border-b border-cs-border">
                            <tr>
                                <th className="px-4 py-2 text-[11px] font-semibold text-cs-muted uppercase tracking-wide">
                                    Name
                                </th>
                                <th className="px-4 py-2 text-[11px] font-semibold text-cs-muted uppercase tracking-wide">
                                    Type
                                </th>
                                <th className="px-4 py-2 text-[11px] font-semibold text-cs-muted uppercase tracking-wide">
                                    Description
                                </th>
                                <th className="px-4 py-2 text-[11px] font-semibold text-cs-muted uppercase tracking-wide text-right">
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-cs-border">
                            {evidences.length === 0 && (
                                <tr>
                                    <td
                                        colSpan={4}
                                        className="px-4 py-4 text-xs text-cs-muted text-center"
                                    >
                                        No evidence added yet.
                                    </td>
                                </tr>
                            )}

                            {evidences.map((f, i) => (
                                <tr
                                    key={i}
                                    className="hover:bg-cs-surface-alt transition-colors"
                                >
                                    <td className="px-4 py-2 text-sm text-cs-dark">
                                        {f.name_file_input}
                                    </td>
                                    <td className="px-4 py-2 text-xs text-cs-muted">
                                        {f.document_format}
                                    </td>
                                    <td className="px-4 py-2 text-xs text-cs-muted">
                                        {f.description}
                                    </td>
                                    <td className="px-4 py-2">
                                        <div className="flex justify-end gap-2">
                                            <button
                                                type="button"
                                                onClick={() =>
                                                    setModalPrev({
                                                        show: true,
                                                        url: f.document,
                                                        firma: false,
                                                        title:f.description,
                                                        fileName:f.name_file_input
                                                    })
                                                }
                                                className="
                          inline-flex items-center justify-center
                          h-8 w-8 rounded-lg
                          border border-cs-border
                          bg-cs-bg hover:bg-cs-bg-alt
                          transition-colors
                        "
                                            >
                                                <i className="fas fa-eye text-xs text-cs-primary-dark" />
                                            </button>

                                            <button
                                                type="button"
                                                onClick={() => deleteItem("evidences", f)}
                                                className="
                          inline-flex items-center justify-center
                          h-8 w-8 rounded-lg
                          border border-cs-border
                          bg-cs-bg hover:bg-cs-bg-alt
                          transition-colors
                        "
                                            >
                                                <i className="fas fa-trash text-xs text-cs-danger" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Modal de subida */}
                <UpFile modal={modal} setModal={setModal} evidences={evidences} setEvidences={setEvidences}/>
                {modalPrev.show && 
                    <PreviewPDF modal={modalPrev} setModal={setModalPrev} />
                }
            </div>
        </>
    );
}

export default FileUploader;
